/* tslint:disable */

import { environment } from 'src/environments/environment';
import { recarregarSeOrigemArwDoSemEnvConfig } from '../../../../core/arw-do-reload.service';

export class ApiConfiguration {
  public rootUrl: string;
  public backendUrl: string;

  constructor() {
    const windowRef = typeof window !== 'undefined' ? (window as any) : undefined;

    recarregarSeOrigemArwDoSemEnvConfig(
      ['/consultar-proposta', '/detalhe-proposta/'],
      'ApiConfiguration.constructor'
    );

    // Atualiza o environment conforme o valor de window.envConfig
    let envConfig = environment;
    console.log('[ApiConfiguration] window.envConfig:', windowRef ? windowRef.envConfig : undefined);
    this.backendUrl = envConfig.backendUrl;
    this.rootUrl = this.backendUrl + '/acordo-ressarcimento-app';
    // Log detalhado dos atributos do environment
    console.log('Atributos do environment:');
    Object.keys(envConfig).forEach(key => {
      console.log(`${key}:`, envConfig[key]);
    });
  }
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
